import { images } from "utils/images"
import {
  maxWidth950Landscape,
  maxHeight700,
  masterBreakPoint,
} from "themes/default/breakpoints"

export const styles = {
  container: {
    position: "relative",
    width: "100%",
    minHeight: "100vh",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    "&::before": {
      content: '""',
      position: "fixed",
      top: 0,
      left: 0,
      width: "100vw",
      height: "100vh",
      backgroundImage: `url(${images.studentBg})`,
      backgroundSize: "100% 100%",
      backgroundPosition: "center center",
      backgroundRepeat: "no-repeat",
      zIndex: -1,
      pointerEvents: "none",
      [masterBreakPoint]: {
        backgroundImage: `url(${images.studentBgMobile})`,
      },
    },
    [maxWidth950Landscape]: {
      justifyContent: "flex-start",
    },
    [maxHeight700]: {
      justifyContent: "flex-start",
    },
  },
}
